import type {
    CustomPlatformAssemblyConfig,
    CustomPlatformPropPlacementConfig,
    IndividualContentPlatformPlacementConfig,
} from './IndividualPlatformTypes'

export const level1CustomPlatformAssemblies: readonly CustomPlatformAssemblyConfig[] = [
    {
        name: 'StartAreaRing',
        region: 1,
        count: 4,
        radius: 84,
        arcCoverage: 0.1,
        openingDirectionOffset: 0,
        centerPosition: [0, -1, 0],
        scale: 2,
        contentVariantSequence: [0, 0, 0, 1],
    },
    {
        name: 'StartAreaOuterRing',
        region: 1,
        count: 4,
        radius: 65,
        arcCoverage: 0.2,
        openingDirectionOffset: 0.4,
        centerPosition: [0, -2, 0],
        scale: 2.2,
        contentVariantSequence: [1, 2, 0, 1],
    },
] as const

export const level1CustomPlatformPropPlacements: readonly CustomPlatformPropPlacementConfig[] = [
    {
        name: 'StartAreaTeddy',
        platformRegion: 1,
        propAsset: 'Teddy',
        propPosition: [-25, -2, -110],
        propRotation: [0, 5.2, 0],
        propScale: 5,
        platformScale: 5,
    },
    {
        name: 'StartAreaTeddyFar',
        platformRegion: 1,
        propAsset: 'Teddy',
        propPosition: [-50, 0, -380],
        propRotation: [-1, 5, -0.5],
        propScale: 5,
        platformScale: 5,
    },
    {
        name: 'StartAreaTeddyFront',
        platformRegion: 1,
        propAsset: 'Teddy',
        propPosition: [5, -9, 180],
        propRotation: [-0.5, 2, 1],
        propScale: 5,
        platformScale: 0,
    },
    {
         name: 'StartAreaToyCar',
         platformRegion: 1,
         propAsset: 'ToyCar',
         propPosition: [28, -2, -220],
         propRotation: [0, 5.2, 0],
        propScale: 5,
        platformScale: 5,
    },
    {
        name: 'StartAreaToyCarFar',
        platformRegion: 1,
        propAsset: 'ToyCar',
        propPosition: [-10, -2, -400],
        propRotation: [0, 3.2, 0],
        propScale: 4,
        platformScale: 5,
     },
    {
        name: 'StartAreaToyCarStart',
        platformRegion: 1,
        propAsset: 'ToyCar',
        propPosition: [-40, -8, 140],
        propRotation: [0, -1, 0],
        propScale: 5,
        platformScale: 5.2,
    },
    {
        name: 'Level1Rainbow',
        platformRegion: 1,
        propAsset: 'Rainbow',
        propPosition: [-8, 0, -400],
        propRotation: [0, 4, 0],
        propScale: 0.4,
        platformScale: 0,
    },
    {
        name: 'Level1Cloud',
        platformRegion: 1,
        propAsset: 'Cloud',
        propPosition: [10, 20, -440],
        propRotation: [0, 4, 0],
        propScale: 0.4,
        platformScale: 0,
    },
] as const

export const level1IndividualContentPlatformPlacements: readonly IndividualContentPlatformPlacementConfig[] = [
    {
        name: 'Level1SidePlatform_00',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [18, -2.5, 120],
        platformRotation: [0, -4, 0],
        platformScale: 6.2,
    },
    {
        name: 'Level1SidePlatform_000',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [-20, 0, 110],
        platformRotation: [0, 2, 0],
       platformScale: 4.2,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 1,
        platformPosition: [10, 0, 0],
        platformRotation: [0, 2, 0],
        platformScale: 1.2,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 2,
        platformPosition: [-10, 0, 0],
        platformRotation: [0, -2, 0],
        platformScale: 1.2,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [-50, -1, 5],
        platformRotation: [0, 0.8, 0],
        platformScale: 4,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 2,
        platformPosition: [-40, -1, 45],
        platformRotation: [0, 1.8, 0],
        platformScale: 4,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 1,
        platformPosition: [-50, -1, -40],
        platformRotation: [0, -2, 0],
        platformScale: 5,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 2,
        platformPosition: [-35, -3, -80],
        platformRotation: [0, -2, 0],
        platformScale: 4,
    },
    {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [-15, 0, 20],
        platformRotation: [0, -1.5, 0],
        platformScale: 1.5,
    },
     {
        name: 'Level1SidePlatform_0000',
        platformRegion: 1,
        contentVariant: 1,
        platformPosition: [15, 0, 20],
        platformRotation: [0, -1.5, 0],
        platformScale: 1.5,
    },
    {
        name: 'Level1SidePlatform_01',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [25, 0, -70],
        platformRotation: [0, 0.45, 0],
        platformScale:3.2,
    },
    {
        name: 'Level1SidePlatform_02',
        platformRegion: 1,
        contentVariant: 2,
        platformPosition: [-27, -3, -145],
        platformRotation: [0.2, 1.2, 0],
        platformScale: 3.6,
    },
    {
        name: 'Level1SidePlatform_03',
        platformRegion: 1,
        contentVariant: 1,
        platformPosition: [26, 0, -130],
        platformRotation: [-0.1, 3, -0.2],
        platformScale: 4.5,
    },
    {
        name: 'Level1SidePlatform_04',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [-34, -2, -178],
        platformRotation: [0, 2, 0],
        platformScale: 5,
    },
    {
        name: 'Level1SidePlatform_05',
        platformRegion: 1,
        contentVariant: 2,
        platformPosition: [35, -3, -280],
        platformRotation: [0, 3, 0],
        platformScale: 5.1,
    },
    {
        name: 'Level1SidePlatform_06',
        platformRegion: 1,
        contentVariant: 1,
        platformPosition: [-32, -3, -330],
        platformRotation: [0, 3.4, 0],
        platformScale: 6.5,
    },
    {
        name: 'Level1SidePlatform_07',
        platformRegion: 1,
        contentVariant: 0,
        platformPosition: [-43, -1, -420],
        platformRotation: [0, 0.2, 0],
        platformScale: 6,
    },
    {
        name: 'Level1SidePlatform_08',
        platformRegion: 1,
        contentVariant: 2,
        platformPosition: [12, 0, -358],
        platformRotation: [0, 1.4, 0],
        platformScale: 3,
    },
] as const
